import React, { Fragment } from 'react';

import MiniRankItemButtom from './MiniRankItemButton';

const MiniRankItems = ({ ranks, category, isMobile }) => {
  return ranks.map((rank, idx) => {
    return (
      <MiniRankItemButtom
        rank={rank}
        key={idx}
        currentCategory={category}
        size={isMobile ? 'tiniest' : 'tiny'}
      />
    );
  });
};

const CurrentUserRankButtons = ({ currentRanks, category, isMobile }) => {
  if (currentRanks && currentRanks.length > 0) {
    return (
      <Fragment>
        <p>
          <strong>You are ranked in the following categories this month:</strong>
        </p>
        <div>
          <MiniRankItems ranks={currentRanks} category={category} isMobile={isMobile} />
        </div>
      </Fragment>
    );
  }
  return null;
};

export default CurrentUserRankButtons;
